import { css } from "lit";
import { concatClasses } from "../../../helpers/concatClasses/index.js";
import { BaseComponent } from "../../BaseComponent.js";
const baseStyle = [
  ...BaseComponent.styles,
  css`
    .badgePosition {
      bottom: calc(-0.9 * var(--dsf-base-size));
      left: calc(1.6 * var(--dsf-base-size));
    }
  `
];
const baseClasses = (cmp) => {
  const classes = [
    "relative",
    "w-32",
    "h-32",
    "dsf-text-xxs-semibold",
    "rounded-full",
    "bg-neutral-600",
    "text-neutral-0",
    "flex",
    "justify-center",
    "items-center",
    "border-2",
    "outline-none"
  ];
  if (cmp.dsf_interactive) {
    classes.push("focus:border-secondary-100", "hover:bg-neutral-500", "active:bg-neutral-500");
  }
  if (cmp.dsf_badge !== void 0) {
    classes.push("border-2", "border-neutral-0");
  } else {
    classes.push("border-neutral-600");
    if (cmp.dsf_interactive) {
      classes.push("hover:border-neutral-500");
    }
  }
  if (cmp.dsf_interactive && cmp.imageLoaded) {
    classes.push(
      "hover:after:block",
      'hover:after:content-[""]',
      "hover:after:absolute",
      "hover:after:top-0",
      "hover:after:right-0",
      "hover:after:bottom-0",
      "hover:after:left-0",
      "hover:after:bg-neutral-700",
      "hover:after:opacity-40",
      "hover:after:rounded-full"
    );
  }
  return concatClasses(classes);
};
const badgeClasses = concatClasses([
  "absolute",
  "bg-neutral-100",
  "text-neutral-400",
  "border-neutral-0",
  "border-2",
  "rounded",
  "px-2",
  "whitespace-nowrap",
  "badgePosition",
  "z-1"
]);
const imgClasses = concatClasses([
  "absolute",
  "w-full",
  "h-full",
  "object-cover",
  "rounded-full"
]);
export {
  badgeClasses,
  baseClasses,
  baseStyle,
  imgClasses
};
